module.exports = __webpack_public_path__ + "img/download.8417ee24.png";